module.exports = __webpack_public_path__ + "img/measure.c34e7c37.png";